export const AUTHENTICATED = 'Logged In'
export const CURRENT = 'Current'
